import DynamicFormAndPDFViewer from 'components/form_pdfjs_component'
import React, { Fragment, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getFormInstance, selectAllFields, selectCompletedFields } from '../../slices/formInstanceSlice'
import { selectCurrentStatus } from '../../slices/globalSlice'
import Download from 'components/QuestionnaireRequestAutomated/processor/components/Download'
import { useEventListeners } from '@deathbyjer/react-event-manager'
import useFullscreen from 'components/QuestionnaireRequestAutomated/hooks/useFullscreen'
import FullscreenViewerHeader from '../FullscreenViewerHeader'

export default function AutoQuestionnaireProcessorForm({ formTitle }) {
  const dispatch = useDispatch()
  const loading = useSelector((state) => state.formInstance.loading)
  const formInstanceId = useSelector((state) => state.global.formInstanceId)
  const respondingFiles = useSelector((state) => state.global.respondingFiles)
  const hashedId = useSelector((state) => state.global.hashedId)
  const numberCompletedFields = useSelector(selectCompletedFields).length
  const allFields = useSelector(selectAllFields)
  const numberAllFields = useMemo(() => Object.keys(allFields)?.length, [allFields])
  const currentStatus = useSelector(selectCurrentStatus)

  const { elementRef: pdfViewerRef, isFullscreen, triggerFullscreen, exitFullscreen } = useFullscreen()

  const document = useMemo(() => {
    return [
      {
        type: 'form',
        formId: formInstanceId,
        id: `form-${formInstanceId}`,
      },
      ...respondingFiles.map((file) => ({
        type: 'pdf',
        url: file.url,
        id: `pdf-${file.id}`,
      })),
    ]
  }, [formInstanceId, respondingFiles])

  const renderBtnText = useCallback(() => {
    switch (currentStatus) {
      case 'intake':
        return (
          <span className="dome-p1 dome-color-med-grey">
            {Math.floor((numberCompletedFields / numberAllFields) * 100)}% completed
          </span>
        )
      case 'email sent':
      case 'archived':
      case 'canceled':
        return <Download questionnaireHashedId={hashedId} />
      default:
        return (
          <span className="dome-p1 dome-color-med-grey">
            {numberCompletedFields}/{numberAllFields} fields completed
          </span>
        )
    }
  }, [currentStatus, numberCompletedFields, numberAllFields])

  useEventListeners({
    'signatureAdded': () =>  dispatch(getFormInstance(formInstanceId)),
    'signatureDeleted': () => dispatch(getFormInstance(formInstanceId))
  })

  return (
    <div className="processing-page-form-content">
      <div className="dome-d-flex dome-flex-column dome-gap18">
        <div className="dome-d-flex dome-align-center dome-justify-between">
          <span className="dome-h4 dome-color-lite-grey dome-text-w500">{formTitle}</span>
          <div className="dome-d-flex dome-gap12">
            {loading === 'success' && renderBtnText()}
            <span className="dome-cursor-pointer" onClick={triggerFullscreen}>
              <i className="fa-solid fa-arrow-up-right-and-arrow-down-left-from-center dome-color-dark-grey"></i>
            </span>
          </div>
        </div>
        <div className="processing-page-pdf-form dome-d-flex dome-flex-column dome-align-end">
          {loading === 'success' && (
            <Fragment>
              <div className="form-progress">
                <div
                  className="form-progress-bar"
                  style={{ width: `${Math.floor((numberCompletedFields / numberAllFields) * 100)}%` }}
                ></div>
              </div>
              <div ref={pdfViewerRef} className="dome-full-width dome-full-height processing-page-pdf-form-content">
                {isFullscreen && <FullscreenViewerHeader title={formTitle} onclose={exitFullscreen} />}
                <DynamicFormAndPDFViewer document={document} />
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  )
}
